/* eslint-disable filename-export/match-default-export */
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

// LD bills every distinct context key as a client-side MAU. Without an initial
// context the SDK generates a random anonymous key per browser storage origin,
// so every Cypress test and every per-MR review env minted a new MAU. One shared
// pre-auth key counts once; the real user/org context is identified after login
// (see useLaunchDarklyContextFlags).
export const PRE_AUTH_CONTEXT = {
  kind: 'user',
  key: 'ion-pre-auth',
  anonymous: true,
};

export default function asyncWithMrLaunchDarklyProvider() {
  return asyncWithLDProvider({
    clientSideID: process.env.LAUNCH_DARKLY_CLIENT_ID,
    context: PRE_AUTH_CONTEXT,
  });
}
